<template lang="pug">
.room-images(v-nv:scope="'room-images'")
    .room-image(v-nv, @nv-back="goBack" :style="backgroundStyle")
</template>

<script>
export default {
  name: "room-images",
  computed: {
    data() {
      return {
        room: null
      }
    },
    backgroundStyle() {
      return {
        backgroundImage: this.room ? `url(http://172.16.1.10/uploads/rooms/images/${this.room}.png)` : "none"
      }
    }
  },
  activated() {
    return _$.nav.sync("room-images", true)
  },
  created() {
    const { location } = __.device.get()
    this.room = location.split("_").shift()
  },
  methods: {
    goBack() {
      this.goHome()
    }
  }
}
</script>

<style lang="scss" scoped>
.room-images {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .room-image {
    height: 100%;
    width: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
}
</style>
